import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { dupInsuranceProductTypes, dupPaymentPeriod } from "../../Enums/enumValues";
import { useDupFlowContext } from "../../hooks/useDupContext";
import { Enum } from "../../interfaces/enum";
import { currencyThousandFormat } from "../InputFields/sanitizer/currencyFormat";
import { SummaryTable } from "../summary/SummaryTable";

interface Props {
  fields: Record<string, Field<string>>;
}

export const DupSummaryData = ({ fields }: Props) => {
  const { data } = useDupFlowContext();
  const insuredAmount = data.defaultCoverage.insuredAmount;

  const insuranceDurationType = (dupPaymentPeriod() as Enum[]).filter(
    (x) => x.value === data.defaultCoverage.paymentPeriod
  );
  const insuranceDuration = insuranceDurationType.length ? insuranceDurationType[0].label : undefined;

  const dupInsuranceType = (dupInsuranceProductTypes() as Enum[]).filter(
    (x) => x.value === data.defaultCoverage.insuranceType
  );
  const insuranceType = dupInsuranceType.length ? dupInsuranceType[0].label : undefined;

  const showDuration = insuranceDuration && data.defaultCoverage.insuranceType !== "PurchaseMoneyProduct";

  return (
    <SummaryTable>
      <thead>
        <tr>
          <th colSpan={2}>
            <Text field={fields.InsuranceTitle}></Text>
          </th>
        </tr>
      </thead>
      <tbody>
        {insuranceType && (
          <tr>
            <th>
              <Text field={fields.InsuranceTypeLabel}></Text>
            </th>
            <td>{insuranceType}</td>
          </tr>
        )}
        {insuredAmount && (
          <tr>
            <th>
              <Text field={fields.InsuranceAmountLabel}></Text>
            </th>
            <td>{currencyThousandFormat(insuredAmount)}</td>
          </tr>
        )}
        {showDuration && (
          <tr>
            <th>
              <Text field={fields.InsuranceDurationLabel}></Text>
            </th>
            <td>{insuranceDuration}</td>
          </tr>
        )}
        {data.defaultCoverage.effectiveDate && (
          <tr>
            <th>
              <Text field={fields.InsuranceEffectiveDateLabel}></Text>
            </th>
            <td>{data.defaultCoverage.effectiveDate}</td>
          </tr>
        )}
      </tbody>
    </SummaryTable>
  );
};
